import { type FC } from 'react'

import { productAccessorGetProductNameWithPromotionName } from '../../../model/productAccessor/productAccessorGetProductNameWithPromotionName'
import { useProductPageContext } from '../../productPageContext'

export const ProductHeadTitle: FC = () => {
  const { currentOffer, product } = useProductPageContext()

  const title = currentOffer
    ? productAccessorGetProductNameWithPromotionName(currentOffer, product)
    : product.name

  return (
    <h1
      className="mb-2.5 flex-1 break-words text-xl font-medium mobile:text-2xl tablet:mb-0"
      data-qa-id="product-title"
    >
      {title}
    </h1>
  )
}
